import { ApiConfig } from '@ajin/config/api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class TranslocoHttpLoader implements TranslocoLoader {

	constructor(private httpClient: HttpClient) { }

	getTranslation(lang: string): Observable<Translation> {
		return new Observable(observer => {
			this.httpClient.get<Translation>(ApiConfig.url + 'languages/current').subscribe({
				next: (result) => {
					let translation: Translation = {};

					if (!result) {
						observer.next(translation);
						observer.complete();
					}

					for (const item of result.items) {
						translation[item.key] = item.value;
					}

					observer.next(translation);
					observer.complete();
				},
				error: (error) => {
					observer.error(error);
					observer.complete();
				}
			});
		});
	}
}
